export const environment = {
    production: true,
    deploy_environment: 'justice',
    test_environment: undefined,
};
